import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, type LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

// Breadcrumb-Zurück-Link (Pfeil + Parent-Name). Auch in den Loading/Error-States
// der Detailseiten genutzt, damit der Weg zurück immer da ist (Test: getByText(parent)).
export function BackLink({ to, label }: { to: string; label: string }) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-text3 transition-colors hover:text-text"
    >
      <ArrowLeft className="h-[15px] w-[15px]" /> {label}
    </Link>
  );
}

// #design-pass W5: geteilter Detail-Header — Breadcrumb + Gradient-Icon-Box + Titel +
// Badge + Sub + rechtsbündige Aktionen. Einheitlich für Channel/Node/User/BrainImage/
// SettingsProfile-Detailseiten (Muster aus Agents/Detail). DRY: ein Header, viele Seiten.
export function DetailHeader({
  backTo,
  backLabel,
  icon: Icon,
  title,
  mono = false,
  badge,
  sub,
  actions,
}: {
  backTo: string;
  backLabel: string;
  icon: LucideIcon;
  title: string;
  mono?: boolean;
  badge?: ReactNode;
  sub?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div>
      <BackLink to={backTo} label={backLabel} />
      <div className="mt-3.5 flex items-start gap-4">
        <div className="grid h-[52px] w-[52px] shrink-0 place-items-center rounded-[13px] border border-accent-border bg-gradient-to-br from-accent-soft to-surface2 text-accent">
          <Icon className="h-[25px] w-[25px]" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-3">
            <h1 className={cn("m-0 break-words text-[21px] font-extrabold tracking-tight text-text", mono && "mono")}>
              {title}
            </h1>
            {badge}
          </div>
          {sub && <p className="mt-1.5 text-[13.5px] text-text2">{sub}</p>}
        </div>
        {actions && <div className="flex shrink-0 flex-wrap justify-end gap-2">{actions}</div>}
      </div>
    </div>
  );
}
